import { render, staticRenderFns } from "./to-audit-proJect-list.vue?vue&type=template&id=2d3c79e5&scoped=true"
import script from "./to-audit-proJect-list.vue?vue&type=script&lang=js"
export * from "./to-audit-proJect-list.vue?vue&type=script&lang=js"
import style0 from "./to-audit-proJect-list.vue?vue&type=style&index=0&id=2d3c79e5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c79e5",
  null
  
)

export default component.exports